import '@/assets/styles/components/layout.styles.scss';
import { Header, SignUp } from '@/components';
import { LayoutProps } from './layout.types';
import { useEffect, useState } from 'react';
import { LoginModalProps } from '@/components/sign-up/sign-up.types.ts';
import { HeaderScreenProps } from '@/components/header/header.types.ts';
import { NavigationPath } from '@/router/navigation-path.ts';
import { useNavigate } from 'react-router';

const Layout = ({ children }: LayoutProps) => {
	const navigate = useNavigate();
	const [showSignUp, setShowSignUp] = useState(false);
	const [isMobile, setIsMobile] = useState(false);

	const isLoginPage = location.pathname === NavigationPath.login;

	const onDynamicRegisterOrSignInButton = (): void => {
		if (!isLoginPage && !isMobile) {
			return setShowSignUp(true);
		}
		const navigatePath = isLoginPage ? NavigationPath.createAccount : NavigationPath.login;
		navigate(navigatePath);
	};

	const onHideLoginModal = (): void => {
		setShowSignUp(false);
	};

	const headerProps: HeaderScreenProps = {
		onDynamicRegisterOrSignInButton
	};

	const signUpProps: LoginModalProps = {
		isOpen: showSignUp,
		onClose: onHideLoginModal
	};

	useEffect(() => {
		const checkScreenSize = () => {
			setIsMobile(window.innerWidth < 820);
		};

		checkScreenSize();

		window.addEventListener('resize', checkScreenSize);

		return () => {
			window.removeEventListener('resize', checkScreenSize);
		};
	}, []);

	return (
		<div className="layout">
			<Header {...headerProps} />
			<div className="layout__content">{children}</div>
			<SignUp {...signUpProps} />
		</div>
	);
};

export default Layout;
